module.exports = __webpack_public_path__ + "img/fe_backdrop_emperor.b69b687e.png";